module.exports = __webpack_public_path__ + "img/logo.36b3591c.png";